import { useMemo } from 'react';

import { getMsUntilNextSecond } from '#shared';

import type { CCSurgeon } from '#entities/types';

import { usePollingQuery, useAggregateRefetch } from '#shared/api';
import type { PollingQueryResult } from '#shared/api';

import { useGetSurgeonsQuery } from '../surgeons.api';

const TARGET_SECOND = 5;

const getSurgeonsDelay = () => getMsUntilNextSecond(TARGET_SECOND);

export const useQuerySurgeons = (): PollingQueryResult<CCSurgeon[]> => {
  const queryResult = useGetSurgeonsQuery(undefined, {
    pollingInterval: 0,
  });

  const { getDelay, refetchSignal } = useAggregateRefetch(
    'surgeons',
    getSurgeonsDelay,
  );
  const pollingResult = usePollingQuery(queryResult, {
    getDelay,
    refetchSignal,
  });

  return useMemo(
    () => ({
      data: pollingResult.data?.data ?? [],
      generatedAt: pollingResult.data?.generatedAt ?? null,
      validation: null, // TODO: add validation when schema validation is added
      isLoading: pollingResult.isLoading,
      isFetching: pollingResult.isFetching,
      isError: pollingResult.isError,
      error: pollingResult.error,
      lastSentTime: pollingResult.lastSentTime,
      lastReceiveTime: pollingResult.lastReceiveTime,
    }),
    [pollingResult],
  );
};
